module.exports = {"ru":{"notificationTitle":"Уведомление"},"en":{"notificationTitle":"Notification"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/notification/.variant/base/text.yaml
// module id = 126
// module chunks = 0